<mat-form-field [appearance]="appearance()" class="carrier-multi-select">
  <mat-label>{{ labelKey() | translate }}</mat-label>
  <mat-select [formControl]="selectControl" multiple (blur)="onTouched()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterControl"
        [placeholderLabel]="'common.search' | translate"
        [noEntriesFoundLabel]="'carrier-multi-select.no-matching' | translate"
      ></ngx-mat-select-search>
    </mat-option>
    @for (carrier of (filteredCarriers$ | async) ?? []; track carrier.id) {
      <mat-option [value]="carrier.id">
        {{ carrier.clinicCarrierName }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
